module.exports = __webpack_public_path__ + "img/icon_logo_grey.4da1d613.svg";